// extracted by mini-css-extract-plugin
export default {"main":"Section_main__rULXj"};